module.exports = __webpack_public_path__ + "img/frame (19).2ce5ba67.jpg";